import * as React from 'react';
import S from './CategoryTags.styles';
import { getSvgIcon } from '@helpers/icons';
const CategoryTags = (props) => {
    if (!props.tags || props.tags.length === 0) {
        return null;
    }
    return React.createElement(S.Container, null, props.tags?.map((tag) => (React.createElement(S.Tag, { key: `${props.id}-${tag.id}`, "data-theme": tag.theme },
        React.createElement(S.TagInner, null,
            tag.icon && React.createElement(S.TagIcon, null, getSvgIcon(tag.icon)),
            React.createElement(S.TagText, null, tag.text))))));
};
export default CategoryTags;
